<template>
  <div v-if="config.appearance === 'input' && !hasLimitsAndNotSerpHighlight" class="relative hidden xl:block">
    <UiInput
      :model-value="props.params.ort"
      :design="ruesSearchbar ? 'ruesSearchbar' : searchresultSearchbar ? 'searchresultSearchbar' : 'normal'"
      :inputstyle="ruesSearchbar || searchresultSearchbar ? 'inside' : ''"
      :placeholder="ruesSearchbar || searchresultSearchbar ? t('where_to_go') : ''"
      name="ort"
      type="text"
      :autocomplete="false"
      :clear-button="true"
      @update:model-value="update('ort', $event)"
      @keydown.enter="chooseRegion($event.target.value)"
    >
      <template #label>
        <span v-if="!ruesSearchbar && !searchresultSearchbar">
          {{ t('ort') }}
        </span>
        <span v-if="ruesSearchbar || searchresultSearchbar">
         {{ t('destination') }}
        </span>
      </template>

      <template #icon>
        <UiIcon src="/svg/icons/location-simple.svg" width="17" height="21" class="stroke-neutral-900 " />
      </template>
    </UiInput>
    <div
      v-if="showDropdown && (searchRegions.length > 0 || showNoResultsMessage)"
      ref="modalWindow"
      class="absolute mt-1 inset-x-0 top-full z-40 bg-white text-left shadow-lg border border-neutral-100 rounded-md"
      @keydown.up.prevent="navigate(-1)"
      @keydown.down.prevent="navigate(1)"
    >
      <div
        v-for="(region, index) in searchRegions"
        :key="region"
        :class="{ 'bg-petrol-500 text-white': selectedIndex === index }"
        class="w-auto hover:bg-petrol-500 hover:text-white py-1 px-2 text-lg cursor-pointer rounded-md"
      >
        <button
          type="button"
          class="btn-reset p-0 w-full text-left"
          @click="chooseRegion(region.name, index)"
        >
          {{ region.name }}
        </button>
      </div>
      <div
        v-if="showNoResultsMessage"
        class="w-auto py-1 px-2 text-lg rounded-md text-neutral-400"
      >
        {{ t('no_results') }}
      </div>
    </div>
  </div>
  <div v-if="config.appearance === 'input' && !hasLimitsAndNotSerpHighlight" class="relative block xl:hidden">
    <UiFakeInput
      :model-value="props.params.ort"
      :design="ruesSearchbar ? 'ruesSearchbar' : searchresultSearchbar ? 'searchresultSearchbar' : 'normal'"
      @update:model-value="update('ort', $event)"
      @keydown.enter="clickTriggerModal"
      @click="clickTriggerModal"
    >
      <template #label>
        <span v-if="!ruesSearchbar && !searchresultSearchbar">
          {{ t('ort') }}
        </span>
        <span v-if="ruesSearchbar || searchresultSearchbar">
         {{ t('destination') }}
        </span>
      </template>

      <template #icon>
        <UiIcon src="/svg/icons/location-simple.svg" width="17" height="21" class="stroke-neutral-900 " />
      </template>
      <template #placeholder>
        {{ t('where_to_go') }}
      </template>
    </UiFakeInput>
    <UiModal
      v-if="showModal"
      :modal-id="modalId"
      :render-if-hidden="false"
      :open="showModal"
      :modal-focus="false"
      :close-with-history-back="false"
      @hidden="showModal = false"
    >
      <template #head>
        {{ t('modal_headline') }}
      </template>
      <UiInput
        ref="modalLocationInput"
        :model-value="props.params.ort"
        design="normal"
        name="ort"
        type="text"
        class="mb-5"
        :autocomplete="false"
        :clear-button="true"
        @update:model-value="update('ort', $event)"
        @keydown.enter="chooseRegion($event.target.value)"
      >
        <template #label>
          <span v-if="!ruesSearchbar">
            {{ t('ort') }}
          </span>
          <span v-if="ruesSearchbar">
           {{ t('destination') }}
          </span>
        </template>
        <template #icon>
          <UiIcon src="/svg/icons/location-simple.svg" width="17" height="21" class="stroke-neutral-900 " />
        </template>
      </UiInput>
      <template v-if="showDropdown && (searchRegions.length > 0 || showNoResultsMessage)">
        <template
          v-for="(region, index) in searchRegions"
          :key="region"
        >
          <button
            type="button"
            :class="{ 'bg-petrol-500 text-white': selectedIndex === index }"
            class="btn-reset w-auto hover:bg-petrol-500 hover:text-white py-3 px-3 text-lg cursor-pointer rounded-md text-left flex gap-3 pick-region"
            @click="chooseRegion(region.name, index)"
          >
            <span>
              <UiIcon src="/svg/icons/location-simple.svg" width="17" height="21" class="stroke-neutral-900 pick-region-icon" aria-hidden="true" />
            </span>
            <span>
              {{ region.name }}
            </span>
          </button>
        </template>
        <div
          v-if="showNoResultsMessage"
          class="w-auto py-1 px-2 text-lg rounded-md text-neutral-400"
        >
          {{ t('no_results') }}
        </div>
      </template>
    </UiModal>
  </div>
  <UiSelect
    v-if="config.appearance === 'select' && !hasLimitsAndNotSerpHighlight"
    :design="ruesSearchbar ? 'ruesSearchbar' : searchresultSearchbar ? 'searchresultSearchbar' : 'normal'"
    name="region"
    label="normal"
    class="font-semibold search-filter-location"
    :model-value="props.params.ort"
    @update:model-value="update('ort', $event)"
  >
    <template #label>
      <span v-if="!ruesSearchbar && !searchresultSearchbar">
        {{ t('ort') }}
      </span>
      <span v-if="ruesSearchbar || searchresultSearchbar">
       {{ t('destination') }}
      </span>
    </template>
    <template #icon>
      <UiIcon src="/svg/icons/location-simple.svg" width="17" height="21" class="stroke-neutral-900" />
    </template>
    <option v-if="!locations?.default" value="">
      {{ config.allg_region }}
    </option>
    <option v-for="{ id, name, lvl } in filteredlocations" :key="id" :value="id" :selected="isLocationSelected(id, name)">
      {{ "\xA0".repeat(lvl*3+3) }}{{ name }}
    </option>
  </UiSelect>
  <template v-if="hasLimitsAndNotSerpHighlight">
    <UiFakeInput
      :model-value="t('mapsearch')"
      :design="ruesSearchbar ? 'ruesSearchbar' : searchresultSearchbar ? 'searchresultSearchbar' : 'normal'"
      :display-inline="false"
      :clear-button="true"
      class="cursor-default block"
      @update:model-value="update('limits', $event)"
    >
      <template #label>
        {{ t('ort') }}
      </template>
      <template #icon>
        <UiIcon src="/svg/icons/location-simple.svg" width="17" height="21" class="stroke-neutral-900 " />
      </template>
    </UiFakeInput>
  </template>
</template>

<script setup lang="ts">
import type { DesignVariant } from '~/types/ui/DesignVariant'
import { isDesignVariant } from '~/types/ui/DesignVariant'
const { translate: t } = useTranslations('SearchFilterLocation')
const { currentPortal } = usePortals()
const searchParamsStore = useSearchParamsStore()
const config = currentPortal.value.search_form
const { locations } = usePortalData()

const emit = defineEmits(['update', 'hide'])
const props = defineProps({
  params: {
    type: Object,
    default: () => ({})
  },
  updateOnInput: {
    type: Boolean,
    default: false
  },
  design: {
    type: String as PropType<DesignVariant>,
    default: '',
    validator: (value: string) => isDesignVariant(value)
  }
})

let localOrt = props.params?.ort ?? ''

const selectedIndex = ref(-1)
const searchRegions = ref([])
const showNoResultsMessage = ref(false)
const showDropdown = ref(false)
const showModal = ref(false)
const modalLocationInput = ref(null)
const regions = ref([])
const modalWindow = ref(null)
const hasLimitsAndNotSerpHighlight = computed(() => props.params.limits && !searchParamsStore.serp_highlight)
const isOnFirstPage = computed(() => searchParamsStore.page < 1)
const ruesSearchbar = computed(() => props.design === 'ruesSearchbar')
const searchresultSearchbar = computed(() => props.design === 'searchresultSearchbar')

const modalId = useComponentId('modal-search-location')

const regionSynonyms = {
  o: ['ø'],
  a: ['å'],
  oe: ['ö'],
  ue: ['ü'],
  ae: ['Æ', 'ä'],
  st: ['st.', 'sankt']
}
function replaceRegionSynonyms (region: string): string {
  let ret = region
  for (const regionSynonymsKey in regionSynonyms) {
    const regionSynonymsList = regionSynonyms[regionSynonymsKey]
    for (const regionSynonymsItem of regionSynonymsList) {
      ret = ret.replaceAll(regionSynonymsItem, regionSynonymsKey)
    }
  }
  return ret
}

async function fetchRegions () {
  const { $backend } = useNuxtApp()
  regions.value = await $backend.regionalAutocomplete.get()
  regions.value = regions.value.data.data
  for (const item of regions.value) {
    item.name_lowercase = item?.name.toLowerCase() ?? ''
    item.name_without_special_characters = item.name_lowercase.replaceAll('.', '').replaceAll('-', ' ')
    item.name_without_synonyms = replaceRegionSynonyms(item.name_without_special_characters)
  }
}

if (config.appearance === 'input') {
  fetchRegions()
}

function navigate (direction) {
  const newIndex = selectedIndex.value + direction
  if (newIndex >= 0 && newIndex < searchRegions.value.length) {
    selectedIndex.value = newIndex
  }
}

function foundRegion (value) {
  let filteredRegions = regions.value.filter((item) => {
    const valueLowercase = value.toLowerCase()
    const valueWithoutSpecialCharacters = valueLowercase.replaceAll('.', '').replaceAll('-', ' ')
    const valueWithoutSynonyms = replaceRegionSynonyms(valueWithoutSpecialCharacters)
    return (item.name_lowercase.startsWith(valueLowercase)) ||
      (item.name_without_special_characters.startsWith(valueWithoutSpecialCharacters)) ||
      (item.name_without_synonyms.startsWith(valueWithoutSynonyms))
  })
  filteredRegions.sort((a, b) => a.name.localeCompare(b.name))
  filteredRegions = filteredRegions.slice(0, 10)
  searchRegions.value = filteredRegions
  if (searchRegions.value.length > 0) {
    showNoResultsMessage.value = false
    return
  }
  showNoResultsMessage.value = true
}

function chooseRegion (region) {
  const trimmedRegion = region.trim()
  searchRegions.value = []
  localOrt = trimmedRegion
  showDropdown.value = false
  if (showModal.value) {
    showModal.value = false
    return
  }
  emit('update', { ort: trimmedRegion })
}

const update = (key, val) => {
  const trimmedVal = val.trim()
  localOrt = trimmedVal

  // In modal: only store locally, no emit → store/URL updated after modal closes
  if (showModal.value && config.appearance === 'input') {
    if (trimmedVal === '') {
      searchRegions.value = []
      showDropdown.value = false
      return
    }
    foundRegion(trimmedVal)
    showDropdown.value = true
    return
  }

  if (trimmedVal === '') {
    emit('update', { [key]: trimmedVal })
    showDropdown.value = false
    return
  }

  if (config.appearance === 'select') {
    emit('update', { [key]: trimmedVal })
    showDropdown.value = false
    return
  }

  if (config.appearance !== 'input') {
    emit('update', { [key]: trimmedVal })
    return
  }

  if (config.appearance === 'input' && props.updateOnInput) {
    emit('update', { [key]: trimmedVal })
  }

  foundRegion(trimmedVal)
  showDropdown.value = true
}

const filterLocations = function (location) {
  if (locations?.hidden?.includes(location.id)) {
    return false
  }
  return true
}
const filteredlocations = config?.places
  ? config.places.filter(filterLocations)
  : []
const isLocationSelected = function (id, name) {
  const defaultLocation = locations?.default ?? null
  const isDefaultLocationSelected = defaultLocation === String(id) || defaultLocation === name
  const isLocalOrtEmpty = localOrt === '' || localOrt === defaultLocation
  if (isLocalOrtEmpty && isDefaultLocationSelected && isOnFirstPage.value) {
    update('ort', locations.default)
    return true
  }
  return name === props.params.ort || id === props.params.ort
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside, true)
  if (import.meta.client) {
    window.addEventListener('popstate', handlePopstate)
  }
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
  if (import.meta.client) {
    window.removeEventListener('popstate', handlePopstate)
  }
})

function updateToFirstDropdownItemIfAvailable () {
  let ortToEmit = localOrt
  if (searchRegions.value.length > 0) {
    ortToEmit = searchRegions.value[0].name
  }

  emit('update', { ort: ortToEmit })
  showDropdown.value = false
}
function handleClickOutside (event) {
  if (!modalWindow.value || modalWindow.value.contains(event.target)) {
    return
  }
  updateToFirstDropdownItemIfAvailable()
}
const clickTriggerModal = () => {
  showModal.value = true
  if (import.meta.client) {
    window.history.pushState({ modalOpen: true, modalId: modalId }, '')
  }
  setTimeout(() => {
    const input = modalLocationInput.value?.$el.querySelector('input')
    if (input) {
      input.focus()
    }
  }, 0)
}

function handlePopstate () {
  if (showModal.value) {
    showModal.value = false
    // watch(showModal) handles updateToFirstDropdownItemIfAvailable + emit
  }
}

watch(showModal, (newValue) => {
  if (!newValue) {
    // If modal state is still in the history stack: replace instead of back()
    // to avoid double navigation and searchParamsWatcher trigger
    if (import.meta.client && window.history.state?.modalId === modalId) {
      window.history.replaceState({}, '')
    }
    updateToFirstDropdownItemIfAvailable()
  }
})

defineExpose({ handlePopstate, showModal })
</script>
<style scoped>
@reference "~/assets/css/main.css";
.pick-region:hover{
  .pick-region-icon{
    @apply fill-white
  }
}
.search-filter-location {
  select.custom-select-fontsize{
    @apply text-lg;
    option{
      @apply text-lg;
    }
  }
}
</style>
